import { messagesListSaga } from './messagesList';
import { messageItemSaga } from './messageItem';

export const messagesSaga = [
    ...messagesListSaga,
    ...messageItemSaga,
];
